import { NavLink } from 'react-router-dom'

import { Theme, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const StyledSideNavBar = styled('div')`
  width: ${componentSizes.leftNavWidth};
  min-width: ${componentSizes.leftNavWidth};
  position: relative;
  color: ${colors.black};
  display: flex;
  flex-direction: column;
  padding-top: 12px;
`

export const PartneringOneWrapper = styled('div')`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  position: -webkit-sticky; // safari prefix
  position: sticky;
  bottom: 0;
`

export const StyledNavLink = styled(NavLink)`
  color: ${colors.bodyText};
  font-size: 32px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.active {
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
  }
`

export const StyledImage = styled('img')`
  width: 40px;
  height: 40px;
`

export const UnreadUpdatesCount = styled('div')`
  background: ${colors.pink};
  height: 18px;
  min-width: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 11px;
  font-weight: 700;
  color: ${colors.white};
  padding: 0 5px;
  position: absolute;
  top: 10px;
  right: 6px;
`
